import React from 'react'
import { IntegrationServiceId } from '../../../common/integrations'
import { Spinner } from '../../Spinner/Spinner'
import { IntegrationFieldValue } from './IntegrationFieldReview'
import { useResolvedReferenceLabel } from './useResolvedReferenceLabel'

export interface IntegrationReferenceCurrentValueProps {
  serviceId: IntegrationServiceId
  referenceObjectName?: string
  value: IntegrationFieldValue
  buildEntityRoutingKey: (kind: 'list' | 'single', referenceObjectName: string) => string
}

export const IntegrationReferenceCurrentValue: React.FC<IntegrationReferenceCurrentValueProps> = ({
  serviceId,
  referenceObjectName,
  value,
  buildEntityRoutingKey,
}) => {
  const id = String(value)
  const { label, isLoading } = useResolvedReferenceLabel(serviceId, referenceObjectName, id, (name) => buildEntityRoutingKey('single', name))
  if (isLoading) {
    return <Spinner size='sm' />
  }
  return <span className='current-data-text'>{label ?? id}</span>
}
